var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { attrs: { id: "registro" } }, [
        _c(
          "div",
          {
            staticClass: "checkContainer",
            staticStyle: { width: "6%" },
            attrs: { id: "headerList-check" }
          },
          [
            _c("input", {
              attrs: { type: "checkbox" },
              on: { change: _vm.checkEvent }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textHeaderList",
            staticStyle: { width: "22%" },
            attrs: { id: "headerList-comprobante" }
          },
          [_vm._v(_vm._s(_vm.item.comprobante))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textHeaderList",
            staticStyle: { width: "8%" },
            attrs: { id: "headerList-tipo" }
          },
          [_vm._v(_vm._s(_vm.item.tipo))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textHeaderList",
            staticStyle: { width: "14%" },
            attrs: { id: "headerList-fecha" }
          },
          [_vm._v(_vm._s(_vm.item.fecha))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textHeaderList",
            staticStyle: { width: "14%" },
            attrs: { id: "headerList-vencimiento" }
          },
          [_vm._v(_vm._s(_vm.item.vencimiento))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textHeaderList",
            staticStyle: { width: "15%" },
            attrs: { id: "headerList-monto" }
          },
          [_vm._v("$ " + _vm._s(_vm._f("formatMoney")(_vm.item.monto)))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              saldoPos: _vm.item.saldo > 0,
              saldoNeg: _vm.item.saldo < 0,
              saldoNeutro: _vm.item.saldo == 0
            },
            staticStyle: { width: "15%" },
            attrs: { id: "headerList-saldo" }
          },
          [_vm._v("$ " + _vm._s(_vm._f("formatMoney")(_vm.item.saldo)))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textHeaderList",
            staticStyle: { width: "6%" },
            attrs: { id: "headerList-ver" }
          },
          [
            _c("img", {
              attrs: { id: "iconVer", src: "/dist/icon-ver.png" },
              on: { click: _vm.btnVerDetalle }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "separator",
        staticStyle: {
          width: "100%",
          height: "1px",
          "background-color": "#dddddd"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-502482c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-502482c1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/cuentaCorriente/itemCuentaCorriente.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-502482c1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/cuentaCorriente/itemCuentaCorriente.vue
// module chunks = 0